import React, { FunctionComponent, ReactElement } from "react";
import { Route, Routes } from "react-router-dom";
import { Garages } from "@App/Pages/Common/Garages";
import { Profile } from "@App/Pages/Common/Profile";
import { Contact } from "@App/Pages/Common/Contact";
import { Summary } from "@App/Pages/Common/Summary";
import { useNavigateWithQueryParams } from "@App/hooks/useNavigateWithQueryParams";
import { CommonRoutes } from "@App/routes/Partner/common";

export type DefaultRoutesProps = {
  layout: ReactElement;
  home: ReactElement;
  redirectOnMiss?: ReactElement;
};

export const DefaultRoutes: FunctionComponent<DefaultRoutesProps> = ({
  layout,
  home,
  redirectOnMiss,
}: DefaultRoutesProps) => {
  // URL & Routes
  const { navigateWithQuery } = useNavigateWithQueryParams();

  return (
    <Routes>
      <Route element={layout}>
        <Route
          index
          element={React.cloneElement(home, {
            onSubmit: () => navigateWithQuery(CommonRoutes.garageList.relative, false),
          })}
        />
        <Route
          path={`${CommonRoutes.garageList.absolute}`}
          element={
            <Garages
              onSubmit={() => navigateWithQuery(`../${CommonRoutes.garageProfile.relative}`, true)}
            />
          }
        />
        <Route
          path={`${CommonRoutes.garageProfile.absolute}`}
          element={
            <Profile onSubmit={() => navigateWithQuery(CommonRoutes.checkout.relative, true)} />
          }
        />
        <Route
          path={`${CommonRoutes.checkout.absolute}`}
          element={
            <Contact onSubmit={() => navigateWithQuery(CommonRoutes.success.relative, true)} />
          }
        />
        <Route path={`${CommonRoutes.success.absolute}`} element={<Summary />} />
        {redirectOnMiss && <Route path={"*"} element={redirectOnMiss} />}
      </Route>
    </Routes>
  );
};
